// Libs
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select'


// Components & Utils
import MenusApi from "../api/Menus";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";
import { TEMPERATURES } from "../utils/Constants";

export default function MealSelect(props) {
  // State
  const [{ sysCfg, user }, dispatch] = useGlobalValue();
  const [menuMeals, setMenuMeals] = useState([]);
  const [selectedMeal, setSelectedMeal] = useState(0);
  const [selectedProp, setSelectedProp] = useState(0);
  const [selectedTemp, setSelectedTemp] = useState(4);
  const [selectedMealComments, setMealComments] = useState("");
  const [qty, setQty] = useState(1);
  const [meal_temperatures, setMealTemps] = useState(TEMPERATURES);
  const addMeal = () => {
    if (qty < 1) {
      alert("Please select a qty greater than 0");
      return;
    }

    if (selectedMeal === 0) {
      alert("Please select a meal");
      return;
    }

    const meal = {
      meal_id: menuMeals[selectedMeal].meal_id,
      qty: qty,
      name: menuMeals[selectedMeal].meal_name,
      property: selectedProp,
      menu_id: props.menuId,
      temperature: selectedTemp,
      comments: selectedMealComments
    };
    props.onAdd(meal);
  };

    // Update Temperature Selection
    useEffect(() => {
      if (menuMeals[selectedMeal] !== undefined) {
        const mealTemps = menuMeals[selectedMeal].temperatures;

        if (mealTemps.length !== 0) {
          setMealTemps(mealTemps);

          const defaultSystemMealTemp = sysCfg.default_temperature;

          //if default temperature is available and automatically select it
          if (Object.keys(mealTemps).length > 0 && mealTemps[defaultSystemMealTemp] !== undefined) {
            setSelectedTemp(mealTemps[defaultSystemMealTemp]);

          // Set default temp to N/A
          } else {
            setSelectedTemp(4);
          }
        }
      }
    }, [menuMeals, selectedMeal, sysCfg.default_temperature]);

  // Track changes on Menu value
  useEffect(() => {
    if (+props.menuId === 0) {
      setMenuMeals([]);
      return;
    }

    setIsLoading(true, dispatch);

    MenusApi.getMealsForMenuOnDate(props.menuId, props.date, user.client_id)
      .then(meals => {
        let mealsById = {};
        meals.map(meal => (mealsById[meal.meal_id] = meal));
        setMenuMeals(mealsById);
        setIsLoading(false, dispatch);
      })
      .catch(apiErrors => {
        setIsLoading(false, dispatch);
        setErrors(apiErrors, dispatch);
      });
  }, [props.menuId, props.date, user.client_id, dispatch]);

  if (menuMeals.length === 0) {
    return <>No meals available on {props.date.format("DD/MM/YYYY")}</>;
  }

  return (
    <>
      Select Meals:
      <div className="row">
        <div className="col-3">
          <input type="number" className="form-control" value={qty} onChange={e => setQty(e.target.value)} />
        </div>
        <div className="col-7">
          <Select
            onChange={selectedMeal => {
              setSelectedMeal(selectedMeal.value);
              setSelectedProp(0);
            }}
            options={Object.keys(menuMeals).map(key => {
              const meal = menuMeals[key];
              return { value: meal.meal_id, label: meal.meal_name }
            }).sort((a,b) => a.label > b.label ? 1 : -1)}
          />
        </div>
        <div className="col-2">
          <button className="btn btn-info btn-block btn-sm" onClick={() => addMeal()}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </div>
      {/* ****** Meal Property ****** */}
      {selectedMeal > 0 && menuMeals[selectedMeal] && menuMeals[selectedMeal].properties && sysCfg.mealordering_properties && +sysCfg.mealordering_properties === 1 && menuMeals[selectedMeal].properties.length > 0 ? (
        <div className="row" style={{ marginTop: 10 }}>
          <div className="col-sm-3">
            <label>Type:</label>
          </div>
          <div className="col-sm-7">
            <select className="form-control" onChange={e => setSelectedProp(e.target.value)}>
              <option value="0">Normal</option>
              {menuMeals[selectedMeal].properties.map(property => (
                <option key={property.id} value={property.property_id}>
                  {property.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* ****** Meal Temperature ****** */}
      {sysCfg.mealordering_add_meal_show_temperature &&
        +sysCfg.mealordering_add_meal_show_temperature === 1 &&
        selectedMeal > 0 &&
        Object.keys(menuMeals[selectedMeal].temperatures).length > 0 ? (
        <div className="row" style={{ marginTop: 10 }}>
          <div className="col-sm-3">
            <label>Temperature:</label>
          </div>
          <div className="col-sm-7">
            <select className="form-control" onChange={e => setSelectedTemp(e.target.value)} value={selectedTemp}>
              {Object.keys(meal_temperatures).map(temp_id => (
                <option key={temp_id} value={temp_id}>
                  {TEMPERATURES[temp_id]}
                </option>
              ))}
            </select>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* ****** Meal Comments ****** */}
      <div className="row" style={{ marginTop: 10 }}>
          <div className="col-sm-3">
            <label>Meal Comments:</label>
          </div>
          <div className="col-sm-7">
            <textarea className="form-control" onChange={e => setMealComments(e.target.value)}>
            </textarea>
          </div>
        </div>
    </>
  );
}